import script from "./VendeursIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./VendeursIndex.vue?vue&type=script&setup=true&lang=js"

import "./VendeursIndex.vue?vue&type=style&index=0&id=602d1787&lang=css"

const __exports__ = script;

export default __exports__